<template>
  <base-container ref="container" :isLoading="loading">
    <div
      style="
        position: sticky;
        top: 0;
        left: 0;
        right: 0;
        z-index: 100;
        background-color: white;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 5px 5px;
      "
    >
      <el-input v-model="name" size="mini" placeholder="请输入规则模板名称">
        <template slot="prepend">模板名称</template>
      </el-input>
      <el-button
        type="success"
        size="mini"
        icon="el-icon-check"
        @click="saveRule"
      >
        保存规则
      </el-button>
    </div>
    <div style="margin: 0 5px 5px 5px">
      <el-input
        v-model="remark"
        size="mini"
        type="textarea"
        :rows="3"
        placeholder="请输入规则模板备注"
      >
        <template slot="prepend">模板备注</template>
      </el-input>
    </div>

    <div style="border: 1px #409eff solid; margin: 0 5px">
      <template v-if="rules.length">
        <RuleExpression
          v-for="(rule, index) in rules"
          :key="index"
          :rule="rule"
          @removeCondition="removeCondition(rule, index)"
        ></RuleExpression>
      </template>
      <el-empty v-else description="未设置规则！"></el-empty>
      <div class="padding3">
        <el-button
          type="danger"
          size="mini"
          icon="el-icon-plus"
          @click="addCondition"
        >
          条件
        </el-button>
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-plus"
          @click="addGroup"
        >
          分组
        </el-button>
      </div>
    </div>
  </base-container>
</template>

<script>
import RuleExpression from "./RuleExpression";
import { getRules, saveRules } from "@/api/zl/rule";
export default {
  components: { RuleExpression },
  model: {
    prop: "ruleId",
    event: "change",
  },
  props: {
    ruleId: [Number, String],
  },
  data() {
    return {
      loading: false,
      id: this.ruleId,
      name: "",
      remark: "",
      groups: [],
      rules: [],
    };
  },
  watch: {
    ruleId() {
      this.loadRules();
    },
  },
  created() {
    this.loadRules();
  },
  methods: {
    loadRules() {
      if (this.id) {
        this.loading = true;
        getRules(this.id)
          .then((res) => {
            let data = res.data.data;
            this.name = data.name;
            this.remark = data.remark;
            let ruleList = data.expressions;
            let rootRules = ruleList.filter((r) => r.parentId == "0");
            for (let index = 0; index < rootRules.length; index++) {
              const item = rootRules[index];
              item.compareValue = item.value;
              this.buildRuleGroup(item, ruleList);
            }
            this.rules = rootRules;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    // loadRuleList() {
    //   ruleList().then((res) => {
    //     this.groups = res.data.data;
    //   });
    // },
    ruleChange() {
      this.$emit("change", this.id);
      this.loadRules();
    },
    buildRuleGroup(parent, rules) {
      let children = rules.filter((c) => c.parentId == parent.id);
      parent.children = children;
      if (parent.children.length) {
        for (let index = 0; index < parent.children.length; index++) {
          const item = parent.children[index];
          item.compareValue = item.value;
          this.buildRuleGroup(item, rules);
        }
      }
    },
    removeCondition(rule, index) {
      this.rules.splice(index, 1);
      if (!index && this.rules.length) this.rules[0].linkType = "";
    },
    addCondition() {
      this.rules.push({
        code: "partName",
        compareType: "in",
        multiple: false,
        value: "",
        levelNo: 0,
        compareValue: "",
        linkType: this.rules.length ? "&" : "",
        children: [],
      });
    },
    addGroup() {
      this.rules.push({
        code: "group",
        compareType: "-",
        multiple: false,
        value: "",
        levelNo: 0,
        compareValue: "-",
        linkType: this.rules.length ? "&" : "",
        children: [
          {
            code: "partName",
            compareType: "in",
            multiple: false,
            value: "",
            levelNo: 1,
            compareValue: "",
            linkType: "",
            children: [],
          },
        ],
      });
    },
    saveRule() {
      let bl = this.isRight(this.rules);
      if (!bl) {
        this.$message({ type: "warning", message: "存在规则条件未设置值!" });
        return;
      }
      if (!this.name) {
        this.$message({ type: "warning", message: "规则模板名称必填!" });
        return;
      }
      this.loading = true;
      let data = {
        id: this.id || "",
        name: this.name,
        remark: this.remark,
        expressions: this.rules,
      };
      saveRules(data)
        .then((res) => {
          this.loading = false;
          this.$message({ type: "success", message: "保存成功!" });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    isRight(rules) {
      let right = true;
      rules.forEach((c, i) => {
        c.sortNo = i;
        c.value = c.compareValue;
        right = right && c.value !== "" && c.value !== undefined && c.value !== null;
        if (c.children.length) {
          right = right && this.isRight(c.children);
        }
      });
      return right;
    },
  },
};
</script>

<style scoped>
.rule-container {
  width: 100%;
  height: 100%;
}
</style>
